import { L } from '@lib';
import { Tag } from 'antd';

export const LocalizedMasterBuildStatus = {
  Draft: L('Draft'),
  Active: L('Active'),
  OnHold: L('On hold'),
  Completed: L('Completed'),
  Canceled: L('Canceled'),
};

const tagStyle = { minWidth: 100, textAlign: 'center' as const };

/** The build's own lifecycle, set by the garage. */
export const MasterBuildStatusTag = {
  Draft: <Tag color="default" style={tagStyle}>Draft</Tag>,
  Active: <Tag color="blue" style={tagStyle}>Active</Tag>,
  OnHold: <Tag color="orange" style={tagStyle}>On hold</Tag>,
  Completed: <Tag color="green" style={tagStyle}>Completed</Tag>,
  Canceled: <Tag color="red" style={tagStyle}>Canceled</Tag>,
};

/**
 * Progress across the build's jobs, derived by the API rather than set by anyone - so it is shown
 * in a quieter, borderless style than the status above to keep the two apart at a glance.
 */
export const MasterBuildProgressTag = {
  Empty: <Tag style={tagStyle}>No jobs</Tag>,
  NotStarted: <Tag color="default" style={tagStyle}>Not started</Tag>,
  InProgress: <Tag color="processing" style={tagStyle}>In progress</Tag>,
  Completed: <Tag color="success" style={tagStyle}>All done</Tag>,
};

export type MasterBuildStatusTagObjectKey = keyof typeof MasterBuildStatusTag;
export type MasterBuildProgressTagObjectKey = keyof typeof MasterBuildProgressTag;
export type LocalizedMasterBuildStatusObjectKey = keyof typeof LocalizedMasterBuildStatus;
